import { render, staticRenderFns } from "./TabletRestaurantRow.vue?vue&type=template&id=6aabc2f8&"
import script from "./TabletRestaurantRow.vue?vue&type=script&lang=js&"
export * from "./TabletRestaurantRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
